export interface Theme {
  paper: string;
  paperAlt: string;
  card: string;
  ink: string;
  inkSoft: string;
  inkMute: string;
  line: string;
  blush: string;
  terracotta: string;
  sage: string;
  gold: string;
  likeYes: string;
  likeNo: string;
  shadow: string;
}

export const THEMES: { light: Theme; dark: Theme } = {
  light: {
    paper: '#F5EDE1',
    paperAlt: '#EFE5D5',
    card: '#FBF6EC',
    ink: '#1F1A17',
    inkSoft: '#4A403A',
    inkMute: 'rgba(31,26,23,0.5)',
    line: 'rgba(31,26,23,0.12)',
    blush: '#E8A598',
    terracotta: '#C8553D',
    sage: '#8A9A7B',
    gold: '#D4A85A',
    likeYes: '#8A9A7B',
    likeNo: '#C8553D',
    shadow: '0 10px 30px rgba(60,35,20,0.08), 0 2px 8px rgba(60,35,20,0.05)',
  },
  dark: {
    paper: '#1A1311',
    paperAlt: '#221917',
    card: '#241A17',
    ink: '#F5EDE1',
    inkSoft: '#C9BCAE',
    inkMute: 'rgba(245,237,225,0.5)',
    line: 'rgba(245,237,225,0.12)',
    blush: '#E8A598',
    terracotta: '#E07458',
    sage: '#A0B090',
    gold: '#E0B968',
    likeYes: '#A0B090',
    likeNo: '#E07458',
    shadow: '0 10px 30px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.25)',
  },
};

export const FONTS = {
  display: '"Newsreader", "Cormorant Garamond", Georgia, serif',
  sans: '"Geist", "Inter", -apple-system, system-ui, sans-serif',
  mono: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',
};
